module.exports = __webpack_public_path__ + "static/media/login-bg-img.706e3090.jpg";